import { gql } from '@apollo/client';
import { PostProject } from '../contentPage/postDetail';
import { PostSubcategory } from '../../common/helpers/domain/postCategories';
import { PropertyType } from '../../common/helpers/domain/propertyTypes';
import { VideoType } from '../../common/helpers/domain/videoTypes';

export const HERO_ARTICLES_QUERY = gql`
  query heroArticle(
    $propertyType: String
    $postCategory: [String]
    $tag: String
  ) {
    heroArticle: heroArticlePost(
      propertyType: $propertyType
      postCategory: $postCategory
      tag: $tag
    ) {
      id
      link
      title
      author {
        id
        name
      }
      postCategory
      videoType
      featuredImage {
        url
        title
      }
      project {
        id
        name
        propertyType
        developer
        location {
          zone {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          district {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          road {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
        }
        transportations {
          value
          label
          link
        }
        priceTypes {
          starting_price
          level {
            value
            label
          }
        }
      }
    }
  }
`;

export interface HeroArticlesQueryResponse {
  heroArticle: HeroArticleInfo;
}

export interface HeroArticlesQueryRequest {
  propertyType?: PropertyType;
  postCategory?: PostSubcategory[];
  tag?: string;
}

export interface HeroArticleInfo {
  id: number;
  title: string;
  link: string;
  author: {
    id: number;
    name: string;
  };
  postCategory: PostSubcategory;
  videoType: VideoType;
  featuredImage: {
    url: string;
  };
  project: PostProject;
}
